<template>
  <div class="material-area" v-show="!openSubtitle" :style="{'z-index': getPaneStatus === 'pane-enter' ? 20 : 1}">
    <resourceCategories></resourceCategories>
    <visualSceneArea></visualSceneArea>
  </div>
</template>
<script>
import resourceCategories from './resourcesArea/resourceCategories.vue';
import visualSceneArea from './resourcesArea/visualSceneArea.vue';
import { mapGetters, mapActions } from 'vuex'

export default {
  name: "MaterialArea",
  data () {
    return {}
  },
  computed: {
    ...mapGetters({
      openSubtitle: "subtitle/openSubtitle",
      getPaneStatus: "materialArea/getPaneStatus"
    })
  },
  components: {
    resourceCategories,
    visualSceneArea
  },
  created () {
    this.$bus.on('addCanvas', this.onAddCanvas);
    this.$bus.on('beforeAddToCanvas', this.onBeforeAddToCanvas);
  },
  methods: {
    ...mapActions({
      setRecent: 'resources/setRecent'
    }),
    onAddCanvas () {
      let addingData = this.$store.getters['resources/addingData'];
      addingData.id && this.setRecent({
        type: addingData.type,
        id: addingData.id,
      });
    },
    onBeforeAddToCanvas ({data, type} = {}) {
      let navType = this.$store.getters['materialArea/getChoosedResourceType'];
      let typeMap = {
        scene: 'scene',
        template: 'template',
        bg: 'background',
        word: 'text',
        role: 'character',
        visual: 'material',
        music: 'sound',
      }
      this.$store.commit('resources/setAddingData', {
        type: type || typeMap[navType.key],
        id: data.characterId || data.id
      });
    }
  }
}
</script>
<style lang="scss" scoped>
.material-area {
  position: relative;
  z-index: 20;
  width: 378px;
  height: 100%;
  padding-top: 60px;
  box-sizing: border-box;
  display: flex;
  pointer-events: none;
}
/deep/ .resource-categories {
  pointer-events: all;
}
/deep/ .visual-scene-area {
  pointer-events: all;
}
</style>



// WEBPACK FOOTER //
// src/components/MaterialArea.vue